import React from 'react';
import { useWatch } from 'react-hook-form';
import { useExpenseReceiptTypeIdInputQuery } from '../../../../../../../services';
import { RhCheckbox } from '../../../../../../dum';
import { IExpense, REQUIRE_TAX } from '../expense-form';
import { useSetExpenseTaxRequirement } from '../use-set-expense-tax-requirement';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function ExpenseRequireTaxInput() {
    const { setExpenseTaxRequirement } = useSetExpenseTaxRequirement();
    const { data } = useExpenseReceiptTypeIdInputQuery();
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IExpense['receipt_type_id'];
    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );

    return (
        <RhCheckbox
            name={REQUIRE_TAX}
            label={shortLabel(FIELD_LABELS.require_tax)}
            disabled={!!receiptType && !receiptType.applies_tax}
            onChange={(required) => {
                setExpenseTaxRequirement(!!required);
            }}
        />
    );
}
